import React from "react";
import { Grid } from "@mui/material";
import Card from "./Card";
import "./homepage.css";
import Intro from "./Intro";

function HomePage() {
  return (
    <div className="homepage">
      <Grid
        container
        sx={{
          width: "80%",
          margin: "auto",
          minHeight: "90vh",
        }}
        spacing={2}>
        <Grid
          item
          sm={12}
          md={8}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "80%",
            color: "#fff",
          }}>
          <Intro></Intro>
        </Grid>
        <Grid
          item
          sm={12}
          md={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}>
          <Card></Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default HomePage;
